<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "unknown" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
viewBox = '0 0 32 32'
on:mouseenter
on:mouseleave
on:keypress
on:click
class = { `s8-icon ${ css }` }
fill = '#272711'
>
<!-- eslint-disable max-len -->
    <g>
        <path vector-effect={isScaling ? 'none' : 'non-scaling-stroke'} d="m26.67 7.26-5.56-5a1 1 0 0 0-.67-.26H8.22A3.13 3.13 0 0 0 5 5v22a3.13 3.13 0 0 0 3.22 3h15.56A3.13 3.13 0 0 0 27 27V8a1 1 0 0 0-.33-.74zM24.51 8H21a1 1 0 0 1-1-1V4h.06zM25 27a1.13 1.13 0 0 1-1.22 1H8.22A1.13 1.13 0 0 1 7 27V5a1.13 1.13 0 0 1 1.22-1H18v3a3 3 0 0 0 3 3h4zm-5-12.17a3.84 3.84 0 0 1-1.12 2.71l-1.34 1.34a1.78 1.78 0 0 0-.54 1.29 1 1 0 0 1-2 0 3.84 3.84 0 0 1 1.12-2.71l1.34-1.34a1.78 1.78 0 0 0 .54-1.29A1.83 1.83 0 0 0 16.17 13h-.34A1.83 1.83 0 0 0 14 14.83a1 1 0 0 1-2 0A3.84 3.84 0 0 1 15.83 11h.34A3.84 3.84 0 0 1 20 14.83zm-3 8a1.23 1.23 0 0 1 0 .17 1.05 1.05 0 0 1-.29.71l-.15.12a.76.76 0 0 1-.18.09l-.18.08H16a1 1 0 0 1-.38-.08 1 1 0 0 1-.33-.21A1.05 1.05 0 0 1 15 23a1.23 1.23 0 0 1 0-.19.6.6 0 0 1 .06-.19.76.76 0 0 1 .09-.18 1.58 1.58 0 0 1 .12-.15 1 1 0 0 1 .33-.21 1 1 0 0 1 1.09.21 1.58 1.58 0 0 1 .12.15.76.76 0 0 1 .09.18.6.6 0 0 1 .1.19z"></path>
    </g>
</svg>